import { useOutletContext } from "react-router-dom";

import { RegFormContextType } from "../../type";
import { useRegDetail } from "shared/context/regDetail";

export default function useInvoicePayerRegConfirmationService() {
  const regDetails = useRegDetail();
  const { transactionDetails } = useOutletContext<RegFormContextType>();

  return {
    regDetails,
    transactionDetails
  };
}
